import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      id: 1,
      title: "Premium Fabric Manufacturer & Wholesaler",
      subtitle: "Where Traditional Craftsmanship Meets Modern Quality",
      description: "Discover our extensive collection of premium fabrics - Position Print, Polyester, Natural Crepe, Velvet Embroidery, Chinon, and Shimmer. Expert in manufacturing position print fabrics.",
      cta: "Explore Our Fabrics"
    },
    {
      id: 2,
      title: "Position Print Fabric Specialists",
      subtitle: "Precision Printing & Quality Excellence",
      description: "Expert manufacturers of position print fabrics with luxurious Velvet Embroidery, elegant Natural Crepe, and premium quality materials. Meticulous attention to every print detail.",
      cta: "View Our Collection"
    },
    {
      id: 3,
      title: "Wholesale & Manufacturing Excellence",
      subtitle: "Your Trusted Fabric Partner",
      description: "Specializing in position print fabrics, Polyester, Chinon, Shimmer and more. Bulk wholesale, custom printing, and competitive prices for all your fabric needs.",
      cta: "Get Wholesale Quote"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [heroSlides?.length]);

  const handleGetQuote = () => {
    navigate('/contact');
  };

  const handleViewPortfolio = () => {
    navigate('/portfolio');
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides?.length) % heroSlides?.length);
  };

  return (
    <section className="relative min-h-screen bg-gradient-heritage overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 heritage-pattern opacity-5"></div>
      
      {/* Hero Slider */}
      <div className="relative min-h-screen flex flex-col">
        {/* Main Content Area */}
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-0">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              {/* Content - Text Slides */}
              <div className="relative order-2 lg:order-1">
        {heroSlides?.map((slide, index) => (
          <div
            key={slide?.id}
                    className={`transition-opacity duration-1000 ${
                      index === currentSlide ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'
                    }`}
                  >
                    <div className="space-y-6 lg:space-y-8">
                      <div className="space-y-3 lg:space-y-4">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-poppins font-bold text-white leading-tight">
                    {slide?.title}
                  </h1>
                        <h2 className="text-lg sm:text-xl md:text-2xl font-inter font-medium text-golden opacity-90">
                    {slide?.subtitle}
                  </h2>
                        <p className="text-base sm:text-lg text-white/80 max-w-xl leading-relaxed">
                    {slide?.description}
                  </p>
                </div>

                      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <Button
                    variant="default"
                    size="lg"
                          className="btn-golden golden-accent w-full sm:w-auto"
                    onClick={handleGetQuote}
                    iconName="MessageSquare"
                    iconPosition="left"
                    iconSize={20}
                  >
                    Get Instant Quote
                  </Button>
                  <Button
                    variant="outline"
                    size="lg"
                          className="border-white text-white hover:bg-white hover:text-primary w-full sm:w-auto"
                    onClick={handleViewPortfolio}
                    iconName="Eye"
                    iconPosition="left"
                    iconSize={20}
                  >
                    {slide?.cta}
                  </Button>
                </div>

                {/* Trust Indicators */}
                      <div className="flex items-center justify-center sm:justify-start gap-4 sm:gap-8 pt-6 lg:pt-8">
                  <div className="text-center">
                          <div className="text-xl sm:text-2xl font-bold text-golden">10+</div>
                          <div className="text-xs sm:text-sm text-white/70">Years Experience</div>
                  </div>
                  <div className="text-center">
                          <div className="text-xl sm:text-2xl font-bold text-golden">1500+</div>
                          <div className="text-xs sm:text-sm text-white/70">Happy Clients</div>
                  </div>
                  <div className="text-center">
                          <div className="text-xl sm:text-2xl font-bold text-golden">5+</div>
                          <div className="text-xs sm:text-sm text-white/70">Fabric Varieties</div>
                  </div>
                </div>
              </div>
                  </div>
                ))}
              </div>

              {/* Video - Static (Always Visible on All Devices) */}
              <div className="order-1 lg:order-2 flex items-center justify-center">
                <div className="relative w-full">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-transparent rounded-2xl pointer-events-none z-10"></div>
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-2xl shadow-heritage"
                  >
                    <source src="/assets/portfolio/Hero_section.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Controls */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex items-center space-x-3 sm:space-x-4 z-20">
          <button
            onClick={prevSlide}
            className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200"
            aria-label="Previous slide"
          >
            <Icon name="ChevronLeft" size={20} />
          </button>

          <div className="flex space-x-2">
            {heroSlides?.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-colors duration-200 ${
                  index === currentSlide ? 'bg-golden' : 'bg-white/40'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200"
            aria-label="Next slide"
          >
            <Icon name="ChevronRight" size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;